import { BRAND } from './brand';

const PRODUCTION_API_ORIGIN = 'https://api.fattah.in';

export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? PRODUCTION_API_ORIGIN,
  appName: import.meta.env.VITE_APP_NAME ?? BRAND.name,
} as const;

/** Normalize VITE_API_URL to include Spring context path when only the API host is set. */
function normalizeApiUrl(configured: string): string {
  const trimmed = configured.replace(/\/$/, '');
  if (trimmed === PRODUCTION_API_ORIGIN) {
    return `${PRODUCTION_API_ORIGIN}/api`;
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

/** Absolute API base for axios, webhooks, and file URLs (works in browser and Electron file://). */
export function getApiBaseUrl(): string {
  const configured = normalizeApiUrl(env.apiUrl);
  if (configured.startsWith('http://') || configured.startsWith('https://')) {
    return configured;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${configured}`;
  }
  return configured;
}
